import { createReducer } from 'redux-starter-kit';
import { authActions } from '../actions';

const {
  authSuccess, authFailure, setLastAuthUserId, resyncAuthUser,
} = authActions;

export const usersInitialState = {
  authUser: null,
  lastAuthUserId: null,
  isMaxAttemptsExceeded: sessionStorage.getItem('isMaxAttemptsExceeded') === 'true',
};

function setMaxLoginAttemptsExceeded(isMaxAttemptsExceeded) {
  sessionStorage.setItem('isMaxAttemptsExceeded', isMaxAttemptsExceeded.toString());
  return isMaxAttemptsExceeded;
}

const authSuccessClbk = (state, action) => ({
  ...state,
  authUser: action.payload,
  isMaxAttemptsExceeded: setMaxLoginAttemptsExceeded(false),
});

const authFailureClbk = (state, action) => ({
  ...state,
  authUser: null,
  isMaxAttemptsExceeded: setMaxLoginAttemptsExceeded(action.payload),
});

const setLastAuthUserIdClbk = (state, action) => ({
  ...state,
  lastAuthUserId: action.payload,
});

const resyncAuthUserClbk = (state, action) => ({
  ...state,
  authUser: action.payload,
});

const usersReducer = createReducer(usersInitialState, {
  [authSuccess]: authSuccessClbk,
  [authFailure]: authFailureClbk,
  [setLastAuthUserId]: setLastAuthUserIdClbk,
  [resyncAuthUser]: resyncAuthUserClbk,
});

export default usersReducer;
